var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",style:(_vm.style),on:{"click":function($event){$event.stopPropagation();_vm.remove($event)}}},[(_vm.withButton)?_c('div',{staticClass:"icon-delete-btn",on:{"mousedown":_vm.remove}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248e196c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/Icon.vue
// module id = 146
// module chunks = 1